import request from '@/utils/request'

let NotetakingApi = {
  /*设备订单列表*/
  orderList(data, errorback) {
    return request._post('/shop/notetaking.order/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/notetaking.setting/index', data, errorback);
  },
  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/notetaking.setting/index', data, errorback);
  },
  audit(data, errorback) {
    return request._post('/shop/notetaking.order/audit', data, errorback);
  },
  

}

export default NotetakingApi;



// WEBPACK FOOTER //
// ./src/api/notetaking.js